import { company, UserType, Company } from 'toolbandi-ui-lib';
import { Component, OnInit, Input } from '@angular/core';
import { ParamsService, Search } from 'elbuild-ui-lib-core';
import { Router, ActivatedRoute } from '@angular/router';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-user-list-filters',
	templateUrl: './user-list-filters.component.html',
	styleUrls: ['./user-list-filters.component.scss']
})
export class UserListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;
	active: boolean = true;

	@Input()
	companyid: number;
	company: {
		search: Search,
		selected: Company
	};

	utypes: string[] = Object.keys(UserType);
	get isCompany(): boolean {
		return this.searchparams.simpleTmp['utype'] && this.searchparams.simpleTmp['utype'] === UserType.company;
	}

	constructor(router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService) {

		super(router, _route, paramsService);

		this.company = {
			search: new Search('company'),
			selected: undefined
		};
	}

	ngOnInit() {
		this.searchparams.addSimpleFilter('utype', UserType.admin);
	}

	readQueryParams(params: string) {

		super.readQueryParams(params);

	}

	setParams() {
		if (this.searchparams.simpleTmp['utype'] === 'all') {
			this.searchparams.removeSimpleFilter('utype');
		}

		if (this.isCompany && this.company.selected) {
			this.searchparams.addSimpleFilter('companyid', this.company.selected.id);
		} else {
			this.searchparams.removeSimpleFilter('companyid');
			this.company.selected = undefined;
		}

		if (this.active) {
			this.searchparams.addSimpleFilter('status', 'active');
		} else {
			this.searchparams.removeSimpleFilter('status');
		}
	}

	resetSearch() {
		this.keyword = undefined;
		this.active = true;
		super.resetSearch();
	}

	search(keeppage?: boolean) {
		this.setParams();
		super.search(keeppage);
	}

}
